// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import { put, call, takeEvery } from 'redux-saga/effects';

import { contactService, contactPageDataService } from './service';
import * as contactActions from './actions';
import * as types from './actionTypes';

function* contactSaga(payload) {
  const res = yield call(contactService, payload.data);
  if (res.ok) {
    yield put(contactActions.setMessage({
      status: true,
      message: 'Your message successfully send. Thanks!',
    }));
  } else {
    yield put(contactActions.setMessage({
      status: false,
      message: 'Some trouble. Try again.',
    }));
  }
}

function* contactRequestPageSaga() {
  const res = yield call(contactPageDataService);
  if (res.ok) {
    const result = res.body.items[0];
    const { title, email, phone } = result;
    yield put(contactActions.requestPageDataSuccess({
      title,
      email,
      phone,
    }));
  }
}

const contactSagas = [
  takeEvery(types.SEND_CONTACT_FORM, contactSaga),
  takeEvery(types.CONTACT_REQUEST_PAGE_DATA, contactRequestPageSaga),
];

export default contactSagas;
